import Bottle from '../../assets/images/projects/bottle.svg'
import LiftAndShift from '../../assets/images/projects/lift_and_shift.gif'
import NewEquipment from '../../assets/images/projects/new_equipment.gif'
import Packaging from '../../assets/images/projects/new_packaging.gif'
import Reformulation from '../../assets/images/projects/reformulation.gif'
import SupplyChain from '../../assets/images/projects/supply_chain.gif'

export const ProjectsData = [
  {
    title: 'New Product Proposition',
    description: 'Launch a new brand, extend a line or create a new benefit.',
    img: Bottle,
  },
  {
    title: 'New Packaging',
    description: 'From creating a new product’s container to reconfiguring a case.',
    img: Packaging,
  },
  {
    title: 'Reformulation',
    description: 'Leveling up our taste to deliver a superior product, without changing its name.',
    img: Reformulation,
  },
  {
    title: 'Lift and Shift',
    description: 'Scaling and customizing products or packaging for each market’s needs.',
    img: LiftAndShift,
    link: '',
  },
  {
    title: 'Supply Chain',
    description: 'Tech-driven perspective to uphold business continuity of existing products, cost savings, and more.',
    img: SupplyChain,
  },
  {
    title: 'New Equipment',
    description: 'Either validating a new piece of equipment from a supplier or building our own.',
    img: NewEquipment,
  },
]
